import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQ } from "@/data/content";
import { Reveal, Eyebrow } from "./Reveal";

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="mx-auto grid max-w-[1400px] gap-12 px-5 py-24 sm:px-8 sm:py-32 lg:grid-cols-12">
    <div className="lg:col-span-4">
      <Reveal><Eyebrow>FAQ</Eyebrow></Reveal>
      <Reveal delay={0.08}><h2 className="mt-6 font-display text-4xl sm:text-5xl font-semibold leading-[1] tracking-[-0.03em]">Gute Fragen.</h2></Reveal>
    </div>
    <Reveal delay={0.1} className="lg:col-span-8">
      <Accordion type="single" collapsible className="border-t border-white/10">
        {FAQ.map((f, i) => (
          <AccordionItem key={f.q} value={`f${i}`} className="border-white/10">
            <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-6 text-left font-display text-lg sm:text-2xl font-medium tracking-[-0.01em] hover:no-underline hover:text-[var(--lagoon)]">{f.q}</AccordionTrigger>
            <AccordionContent data-testid={`faq-content-${i}`} className="pb-6 text-base text-[var(--mist)]">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </Reveal>
  </section>
);
